import React from 'react';
import { Modal, FormGroup, FormControl, OverlayTrigger, Button, Popover } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { daysBetween } from '../../../core/date';

function findById(value) {
  return value.id === Number(this);
}

function compareGroupEvents(a, b) {
  if (a.group_name < b.group_name) {
    return -1;
  }
  if (a.group_name > b.group_name) {
    return 1;
  }
  return 0;
}


const formatMoney = (value, currency) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: 2,
    currency,
  });
  return formatter.format(value);
};

class CompareBidsModal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedState: 0,
      selectedEvent: null
    }
  }

  onCityChange = (e) => {
    if (e.target.value != "0") {
      const selectedEvent = this.props.tour.tour_stops.find(findById, e.target.value);
      this.setState({
        selectedState: e.target.value,
        selectedEvent
      })
      this.props.requestCompareBids(this.props.tour.id, e.target.value)
    } else {
      this.setState({
        selectedState: 0,
        selectedEvent: null
      })
    }
  }

  render() {
    const options = [];
    const stops = this.props.tour.tour_stops;
    for (let i = 0; i < stops.length; i++) {
      const lebal = () =>{
        let location;
        if (stops[i].place.city == null){
          location = `${stops[i].place.state},${stops[i].place.country}`;
        }
        if (stops[i].place.state == null){
          location = `${stops[i].place.city},${stops[i].place.country}`;
        }
        if ( stops[i].place.city == null && stops[i].place.state == null && stops[i].place.country == null){
          location = '';
        }
        if ( stops[i].place.city != null && stops[i].place.state != null && stops[i].place.country != null){
          if (stops[i].place.city === stops[i].place.state){
            location = `${stops[i].place.city}, ${stops[i].place.country}`;
          }
          else{
            if (stops[i].place.state === stops[i].place.country){
              location = `${stops[i].place.city}, ${stops[i].place.country}`;
            }else{
                location = `${stops[i].place.city}, ${stops[i].place.state}, ${stops[i].place.country}`;
              }
          }
        }
        return location;
      }
      options.push(
        <option key={stops[i].id} value={stops[i].id}>
          {lebal()}
        </option>
      );
    }

    const popover = (
      <Popover
        id="popover-basic"
        placement="top"
      >
        Average Rate Per Night is calculated by averaging out the rates provided by Hotels for a room type for different stay dates.
  </Popover>
    );

    let groupEvents = []
    if (this.state.selectedEvent) {
      groupEvents = this.state.selectedEvent.related_group_events.sort(compareGroupEvents).map((event, i) => {
        const suites = event.bids.bid_details.filter(c => c.suite).length
        const kings = event.bids.bid_details.filter(c => c.king).length
        const doubles = event.bids.bid_details.filter(c => c.double).length
        const twobeds = event.bids.bid_details.filter(c => c.twobeds).length
        const juniorsuites = event.bids.bid_details.filter(c =>c.Juniorsuite).length
        const twobedroomsuites = event.bids.bid_details.filter(c=>c.twobedroomsuite).length

        const data = []
        this.props.compareBids.filter(cb => cb.bidset == event.id).map((bid, i) => {
          const gridObj = {
            id: bid.hotel.id,
            name: bid.hotel.name,
            king: 0,
            suite: 0,
            double: 0,
            twobeds:0,
            juniorsuite:0,
            twobedroomsuite:0,
            total: 0,
            currency: bid.hotel.currency
          }
          gridObj.total = bid.bid_bid_details.reduce((accumulator, a) => {
            const additional_tax = bid.hotel.additional_tax
            const resort_fee = bid.resort_fee
            const tax = bid.hotel.tax_rate
            const add = Number(additional_tax)
            const resort = Number(resort_fee)
            const taxValue = Number(tax)
            const tax_rate = taxValue? taxValue: 0
            const addTax = add? add : 0
            const resortFee = resort? resort : 0
            const diff = daysBetween(a.bid_details.check_out_date, a.bid_details.check_in_date);
            const add_Tax = Number(addTax) * diff
            const rert_fee = Number(resortFee) * diff
            const rate_per_night = Number(a.rate_per_night)
            const taxRat = tax_rate * rate_per_night
            const taxRate = taxRat * diff
            return accumulator + (Number(a.rate_per_night) * diff) + add_Tax + rert_fee + taxRate;
          }, 0);

          gridObj.total = gridObj.total;      

          const kings = bid.bid_bid_details.filter(c => c.bid_details.king)
          const suites = bid.bid_bid_details.filter(c => c.bid_details.suite)
          const doubles = bid.bid_bid_details.filter(c => c.bid_details.double)
          const twobeds = bid.bid_bid_details.filter(c => c.bid_details.twobeds)
          const juniorsuites = bid.bid_bid_details.filter(c => c.bid_details.Juniorsuite)
          const twobedroomsuites = bid.bid_bid_details.filter(c => c.bid_details.twobedroomsuite)

          if (kings.length != 0) {
            gridObj.king = kings.reduce((accumulator, a) => accumulator + Number(a.rate_per_night), 0) / kings.length;
          }

          if (suites.length != 0) {
            gridObj.suite = suites.reduce((accumulator, a) => accumulator + Number(a.rate_per_night), 0) / suites.length;
          }

          if (doubles.length != 0) {
            gridObj.double = doubles.reduce((accumulator, a) => accumulator + Number(a.rate_per_night), 0) / doubles.length;
          }
          if(twobeds.length !=0){
            gridObj.twobed = twobeds.reduce((accumulator,a)=>accumulator + Number(a.rate_per_night), 0) / twobeds.length;
          }
          
          if(juniorsuites.length !=0){
            gridObj.juniorsuite = juniorsuites.reduce((accumulator,a)=>accumulator+ Number(a.rate_per_night),0) / juniorsuites.length;
          }
          if(twobedroomsuites.length !=0){
            gridObj.twobedroomsuite = twobedroomsuites.reduce((accumulator,a)=> accumulator + Number(a.rate_per_night),0) / twobedroomsuites.length;
          }
          data.push(gridObj)
        })
        
        return (
          <div key={i} className="col-md-12">
            <h3>{this.state.selectedEvent.name}</h3>
            <div>
              <p>
                <b>Group</b>: {event.group_name}
              </p>
              <p>
                <b>Stay Dates</b>: {event.start} - {event.end}
              </p>
              <p>
                <b>Suite</b>: {suites} <b>Kings</b>: {kings} <b>Double</b>: {doubles} <b>Two Beds</b>: {twobeds} <b>Junior Suites</b>: {juniorsuites} <b>2 Bedroom Suite</b>: {twobedroomsuites}
              </p>
            </div>
            

            <BootstrapTable
              data={data}
              striped
            > 
              <TableHeaderColumn dataField="name" width="100" isKey headerAlign="center" editable={false}>Hotel</TableHeaderColumn>
              {suites >0 &&
              <TableHeaderColumn dataField="suite" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false} >Suite</TableHeaderColumn>
              }
              {kings >0 &&
              <TableHeaderColumn dataField="king" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false} >Kings</TableHeaderColumn>
              }
              {doubles >0 &&
              <TableHeaderColumn dataField="double" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false}>Double</TableHeaderColumn>
              }
              {twobeds >0 &&
              <TableHeaderColumn dataField="twobed" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false}>Two Beds</TableHeaderColumn>
              }
              {juniorsuites >0 && 
              <TableHeaderColumn dataField="juniorsuite" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false}>Junior Suite</TableHeaderColumn>
              }
              {twobedroomsuites >0 &&
              <TableHeaderColumn dataField="twobedroomsuite" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false}>2 Bedroom Suite</TableHeaderColumn>
              }
              <TableHeaderColumn dataField="total" width="100" headerAlign="center" dataAlign="center" dataFormat={(cell, row) => formatMoney(cell, row.currency)} editable={false}>Total</TableHeaderColumn>
            </BootstrapTable>
          </div>
        )
      });
    }
    return (
      <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Compare Bids</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <FormGroup controlId="hotelSelector">
                  <FormControl
                    componentClass="select"
                    placeholder="Select a city"
                    value={this.state.selectedState}
                    onChange={this.onCityChange}
                  >
                    <option value="0">
                      Select a city
                    </option>
                    {options}
                  </FormControl>
                </FormGroup>
              </div>
            </div>

            <div className="row">
              {groupEvents}
            </div>
            {
              this.state.selectedEvent &&
              <div className="row">
                <div className="col-md-12">
                  <span>*Please note these are
                    <OverlayTrigger rootClose trigger="click" placement="top" overlay={popover}>
                      <Button bsStyle="link" style={{ color: "green", paddingTop: "2px", paddingLeft: "2px", paddingRight: "2px" }}>average</Button>
                    </OverlayTrigger>
                    stay rates of room types. To check the actual rates provided by Hotels, go to Manage Bids
                  </span>
                </div>
              </div>
            }
          </div>
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }

}

export default CompareBidsModal;


// WEBPACK FOOTER //
// src/routes/tours/components/CompareBidsModal.js